import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance1wcuorfuztxv3 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.v5y_1 = call;
        this.w5y_1 = responseData.z5m_1;
        this.x5y_1 = responseData.u5m_1;
        this.y5y_1 = responseData.x5m_1;
        this.z5y_1 = responseData.v5m_1;
        this.a5z_1 = responseData.a5n_1;
        var tmp = this;
        var tmp_0 = responseData.y5m_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.b5z_1 = tmp0_elvis_lhs == null ? Companion_getInstance().e4o_1 : tmp0_elvis_lhs;
        this.c5z_1 = responseData.w5m_1;
      }
      f5m() {
        return this.v5y_1;
      }
      ww() {
        return this.w5y_1;
      }
      o5m() {
        return this.x5y_1;
      }
      p5m() {
        return this.y5y_1;
      }
      q5m() {
        return this.z5y_1;
      }
      r5m() {
        return this.a5z_1;
      }
      n5m() {
        return this.b5z_1;
      }
      e55() {
        return this.c5z_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
